import HttpFactory from '@/mixins/http.factory';
export default {
	name:'enable-syncing',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
		}
	},
	created(){
		//this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');
		},
		showNotFoundError(msg){
			let _self=this;
			_self.userMsg={show:true,type:'danger',list:[msg]};
		}
	}
}

